/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import props from './props.js';
import { renderContent } from '../utils/render-tnode.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import '@babel/runtime/helpers/typeof';
import 'vue';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var classPrefixMixins = getClassPrefixMixins("divider");
var _Divider = mixins(classPrefixMixins).extend({
  name: "TDivider",
  props: _objectSpread({}, props),
  render: function render() {
    var _ref;

    var h = arguments[0];
    var children = renderContent(this, "default", "content");

    if (this.theme) {
      console.warn("TDesign Divider Warn: `theme` is going to be deprecated, please use `layout` instead.");
    }

    var dividerClassNames = ["".concat(this.componentName), ["".concat(this.componentName, "--").concat(this.layout || this.theme || "horizontal")], (_ref = {}, _defineProperty(_ref, "".concat(this.componentName, "--dashed"), !!this.dashed), _defineProperty(_ref, "".concat(this.componentName, "--with-text"), !!children), _defineProperty(_ref, "".concat(this.componentName, "--with-text-").concat(this.align), !!children), _ref)];
    return h("div", {
      "class": dividerClassNames
    }, [children && h("span", {
      "class": "".concat(this.componentName, "__inner-text")
    }, [children])]);
  }
});

export { _Divider as default };
//# sourceMappingURL=divider.js.map
